
up.compiler('.select_month_animation', function(element, data) {
  const selector = new Choices(element, {
    choices: data.map((e, idx) => {
      let res = {
        value: idx + 1, 
        label: e
      }
      let currentMonth = element.dataset.defaultmonth
      if (currentMonth && (res.value.toString() === currentMonth)) {
        res['selected'] = true
      }
      return res
    }),
    placeholder: true,
    placeholderValue: 'Mois',
    removeItemButton: true,
    shouldSort: false,
    classNames: {
      containerOuter: ['choices', 'w-full'],
      containerInner: ['choices__inner', 'text-base', 'flex', 'items-center', 'justify-between', 'rounded-md', 'border', 'border-input', 'bg-white', 'px-4', 'text-base', 'ring-offset-background', 'focus:outline-none', 'focus:ring-2', 'focus:ring-ring', 'focus:ring-offset-2', 'disabled:cursor-not-allowed', 'disabled:opacity-50', '[&>span]:line-clamp-1'],
      input: ['choices__input'],
    }
  });
  
  return () => {
    selector.destroy()
  }
})